exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.google-map[data-v-055689e6] {\n    /* width: 400px; */\n    height: 400px;\n    margin: 0 auto;\n    border:1px solid grey;\n    background: gray;\n}\n", ""]);

// exports
